import React, { useEffect, useState } from "react";
import { IonText, useIonToast } from "@ionic/react";
import { FormattedMessage, useIntl } from "react-intl";
import Spinner from "react-bootstrap/Spinner";
import { useHistory } from "react-router";
import {
  verifyPasswordResetCode,
  confirmPasswordReset,
  signInWithEmailAndPassword,
} from "firebase/auth";

import "./login.css";
import Auth from "../../api/auth";

import styles from "./styles.module.css";
import { auth } from "../../lib/firebase";
interface ResetForm {
  password: string;
  email: string;
}
import { useAuth } from "../../providers/auth";

const ResetPassword = () => {
  const [loading, setLoading] = useState(true);
  const [show, setShow] = useState(false);
  const [resetError, setResetError] = useState(null);
  const [code, setCode] = useState("");
  const [formData, setFormData] = useState<ResetForm>({
    password: "",
    email: "",
  });

  const { refreshUser } = useAuth();

  const history = useHistory();
  const intl = useIntl();
  const [present] = useIonToast();

  useEffect(() => {
    const qs = new URLSearchParams(window.location.search);
    const mode = qs.get("mode");
    const oobCode = qs.get("oobCode");
    if (mode !== "resetPassword" || !oobCode) {
      history.replace("/auth/login");
      return;
    }
    setCode(oobCode);

    verifyPasswordResetCode(auth, oobCode)
      .then((userEmail) => {
        setFormData((prevFormData) => ({ ...prevFormData, email: userEmail }));
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        history.replace("/auth/login");
      });
  }, []);

  const resetApi = async () => {
    try {
      setLoading(true);
      setResetError(null);
      await confirmPasswordReset(auth, code, formData.password);
      const newAuth = await signInWithEmailAndPassword(
        auth,
        formData.email,
        formData.password,
      );
      const hash = await newAuth.user.getIdToken();
      const { data, err } = await Auth.login({ hash });
      if (data) {
        refreshUser(); // refetch user after registration in DB succeded
        setFormData({ password: "", email: "" });
      }

      if (err) {
        setResetError(() => err.message);
      }
    } catch (e) {
      return present({
        message: intl.formatMessage({ id: "common.tryItLater" }),
        duration: 6000,
        color: "light",
        position: "top",
        cssClass: "error-toast",
      });
    } finally {
      setFormData((prevState) => ({ ...prevState, password: "" }));
      setLoading(false);
    }
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    await resetApi();
  };

  const handleChange = (e: React.FormEvent<HTMLInputElement>) => {
    const { value, id } = e.currentTarget;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [id]: value,
    }));
  };

  return (
    <div className={styles.authHolder}>
      <div className={styles.authPanel}>
        <h1>
          <FormattedMessage id="auth.resetPassword.title" />
        </h1>
        <h2>
          <FormattedMessage id="auth.resetPassword.description" />
        </h2>
        <form className={styles.authForm} onSubmit={handleSubmit}>
          <div className={`${styles.inputHolder} ${styles.passwordHolder}`}>
            <label>
              <FormattedMessage id="auth.resetPassword.password" />
            </label>
            <input
              placeholder="Password"
              type={show ? "text" : "password"}
              className="form-control"
              id="password"
              value={formData.password}
              onChange={(e) => handleChange(e)}
              disabled={loading}
              required
            />
            <span
              onClick={() => setShow(!show)}
              className={styles.togglePassword}
            ></span>
          </div>
          {resetError && (
            <p>
              <IonText className="mb-1 color-warning">{resetError}</IonText>
            </p>
          )}
          <button
            type="submit"
            className="btn btn-visito-primary w-100 py-8 mb-4 mt-4 rounded-2"
          >
            {loading ? (
              <Spinner animation="border" role="status" size="sm">
                <span className="visually-hidden">
                  <FormattedMessage id="auth.general.loading" />
                  ...
                </span>
              </Spinner>
            ) : (
              <FormattedMessage id="auth.resetPassword.submit" />
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
